export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7f72d2ea6d04f29c80a44dee6bff7de2.jpg"
          alt="Tecnologia Solus IT"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/75 to-black/90"></div>
        {/* Blue glow effect */}
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 60% 50%, rgba(98,169,224,0.08) 0%, transparent 70%)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center pt-24">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 border text-xs font-semibold px-4 py-1.5 rounded-full mb-8 tracking-wider uppercase"
          style={{
            borderColor: 'rgba(98,169,224,0.4)',
            background: 'rgba(98,169,224,0.08)',
            color: '#62A9E0',
          }}
        >
          <i className="ri-cpu-line"></i>
          Tecnologia para o Futuro
        </div>

        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6 max-w-4xl mx-auto">
          Soluções em{" "}
          <span className="solus-gradient-text">Tecnologia</span>{" "}
          para sua Empresa
        </h1>

        <p className="text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          Transforme seu negócio com consultoria especializada em TI, infraestrutura de servidores, segurança da informação, IA e muito mais. Do diagnóstico à implementação.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => handleNav("#contato")}
            className="px-8 py-3.5 solus-btn-primary font-bold rounded-md text-sm cursor-pointer whitespace-nowrap solus-glow-sm"
          >
            Fale com um consultor
          </button>
          <button
            onClick={() => handleNav("#solucoes")}
            className="px-8 py-3.5 solus-btn-secondary font-semibold rounded-md text-sm cursor-pointer whitespace-nowrap"
          >
            Ver soluções
          </button>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-3 gap-8 max-w-2xl mx-auto pt-10" style={{ borderTop: '1px solid rgba(98,169,224,0.2)' }}>
          {[
            { value: "17+", label: "Anos de experiência" },
            { value: "300+", label: "Clientes atendidos" },
            { value: "15+", label: "Parceiros certificados" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl font-black solus-gradient-text">{stat.value}</div>
              <div className="text-xs text-white/50 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs uppercase tracking-widest" style={{ color: 'rgba(98,169,224,0.6)' }}>Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center" style={{ color: '#62A9E0' }}>
          <i className="ri-arrow-down-line text-lg"></i>
        </div>
      </div>
    </section>
  );
}
